import { Select } from '@bloomfieldrobotics/canopy';
import { Box } from '@mui/material';
import { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { UnitsEnum } from '../../../services/entities/impl/blfApi/apiConstants';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { translateWordsOnly } from '../../../services/translation/impl/i18n/utils/translateWordsOnly';
import { DateRangeFilterSelect } from '../../commonUI/DateRangeFilterSelect/DateRangeFilterSelect';
import { StrictDateRange } from '../../commonUI/DateRangeFilterSelect/types';
import { DateRangeKey } from '../../commonUI/DateRangeFilterSelect/utils/generateDateRangeFilter';
import { useUnits } from '../../settings/hooks/useUnits';
import {
  RanchSummaryTableMeasureEnum,
  selectRanchSummaryTableDateRange,
  selectRanchSummaryTableMeasure,
  setRanchSummaryTableDateRange,
  setRanchSummaryTableMeasure,
} from '../dataGridTablesSlice';
interface Props {
  showCountTypeDropdown?: boolean;
  showDateRangeDropdown?: boolean;
}

const RanchSummaryTableDropdowns: React.FC<Props> = ({
  showCountTypeDropdown = true,
  showDateRangeDropdown = true,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
      {showCountTypeDropdown && <CountTypeDropdown />}
      {showDateRangeDropdown && <DateRangeDropdown />}
    </Box>
  );
};

const CountTypeDropdown = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const units = useUnits();

  const value = useAppSelector(selectRanchSummaryTableMeasure);

  const measureMenuItems = useMemo(
    () =>
      Object.values(RanchSummaryTableMeasureEnum).map((value) => ({
        value,
        label: translateWordsOnly(
          units === UnitsEnum.imperial ? value.replace('Meter', 'Foot') : value,
          t
        ),
      })),
    [t, units]
  );

  const handleChange = (value: RanchSummaryTableMeasureEnum) => {
    dispatch(setRanchSummaryTableMeasure(value));
  };

  return (
    <Select options={measureMenuItems} value={value} onChange={handleChange} />
  );
};

const DateRangeDropdown = () => {
  const dispatch = useAppDispatch();
  const value = useAppSelector(selectRanchSummaryTableDateRange);

  const handleChange = (range: StrictDateRange | null, value: DateRangeKey) => {
    dispatch(setRanchSummaryTableDateRange(value));
  };

  return <DateRangeFilterSelect value={value} onChange={handleChange} />;
};

export default RanchSummaryTableDropdowns;
